"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAccountErrors = exports.ResetPasswordErrors = exports.RequestTwoFaErrors = exports.AuthFlow = void 0;
var AuthFlow;
(function (AuthFlow) {
    AuthFlow["ONBOARDING"] = "ONBOARDING";
    AuthFlow["SIGN_IN"] = "SIGN_IN";
    AuthFlow["OG_REJECT_ONBOARDING"] = "OG_REJECT_ONBOARDING";
    AuthFlow["CONTINUE_ONBOARDING"] = "CONTINUE_ONBOARDING";
    AuthFlow["PHONE_NUMBER_CHANGE"] = "PHONE_NUMBER_CHANGE";
    AuthFlow["WEB_ORIGINATION_TO_NATIVE"] = "WEB_ORIGINATION_TO_NATIVE";
    // @deprecated
    AuthFlow["PASSWORD_RESET"] = "PASSWORD_RESET";
})(AuthFlow || (exports.AuthFlow = AuthFlow = {}));
var RequestTwoFaErrors;
(function (RequestTwoFaErrors) {
    RequestTwoFaErrors["INVALID_US_PHONE_NUMBER"] = "INVALID_US_PHONE_NUMBER";
    RequestTwoFaErrors["INVALID_EMAIL"] = "INVALID_EMAIL";
    RequestTwoFaErrors["PHONE_NUMBER_IS_LANDLINE"] = "PHONE_NUMBER_IS_LANDLINE";
    RequestTwoFaErrors["TOO_MANY_2FA_REQUESTS"] = "TOO_MANY_2FA_REQUESTS";
    RequestTwoFaErrors["UNEXPECTED_TWILIO_RESPONSE"] = "UNEXPECTED_TWILIO_RESPONSE";
})(RequestTwoFaErrors || (exports.RequestTwoFaErrors = RequestTwoFaErrors = {}));
var ResetPasswordErrors;
(function (ResetPasswordErrors) {
    ResetPasswordErrors["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    ResetPasswordErrors["TWO_FA_FAILED"] = "TWO_FA_FAILED";
})(ResetPasswordErrors || (exports.ResetPasswordErrors = ResetPasswordErrors = {}));
var CreateAccountErrors;
(function (CreateAccountErrors) {
    // Purposefully vague so as not to leak account existence.
    CreateAccountErrors["CREATING_ACCOUNT_FAILED"] = "CREATING_ACCOUNT_FAILED";
    CreateAccountErrors["YOUNGER_THAN_MINIMUM_AGE"] = "YOUNGER_THAN_MINIMUM_AGE";
    CreateAccountErrors["INVALID_PASSWORD"] = "INVALID_PASSWORD";
    CreateAccountErrors["OTP_VERIFICATION_FAILED"] = "OTP_VERIFICATION_FAILED";
})(CreateAccountErrors || (exports.CreateAccountErrors = CreateAccountErrors = {}));
